import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  boxShadow: {
    property: 'boxShadow'
  },
  textShadow: {
    property: 'textShadow'
  }
};
const shadow = system(config);

export { shadow };
